import React, { useState, useEffect } from "react";
import { useParams, NavLink } from "react-router-dom";
import { Col } from "reactstrap";
import axios from "axiosClient";
import { useTranslation } from "react-i18next";
import PublicLayout from "components/PublicLayout";
import Verification from "./verification";
import axiosClient from "axiosPaymentClient";

const VerificationHome = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);
  // loading -> ready | notFound | error; the page used to say "no records"
  // while the request was still in flight
  const [status, setStatus] = useState("loading");

  const { t } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get(`/api/payment-info?transactionId=${id}`);
      return data;
    };
    const fetchEnquiryData = async () => {
      // Landing back here after 3-D Secure is not proof the money moved, and the
      // provider webhook can be late or lost. Ask the server to confirm with
      // GlobalPay first; for any other provider this is a harmless no-op.
      try {
        await axiosClient.get(`/api/globalpay/status?enquiryId=${id}`);
      } catch (error) {
        // provider unreachable or not a GlobalPay payment - show what we have
      }
      const { data } = await axiosClient.get(`/api/payment-user/${id}`);
      return data;
    };

    const load = async () => {
      let fetcher = null;
      if (id) {
        if (!isNaN(Number(id)) || id.includes("v")) {
          fetcher = fetchData;
        } else if (id.includes("i")) {
          fetcher = fetchEnquiryData;
        }
      }
      if (!fetcher) return setStatus("notFound");

      try {
        const data = await fetcher();
        setDetails(data || null);
        setStatus(data ? "ready" : "notFound");
      } catch (error) {
        setStatus(error.response?.status === 404 ? "notFound" : "error");
      }
    };
    load();
  }, [id]);

  const renderState = () => {
    if (status === "ready") return <Verification details={details} />;

    if (status === "loading") {
      return (
        <div className="card-body status-panel" aria-busy="true">
          <span
            className="spinner-border text-primary mb-3"
            aria-hidden="true"
          />
          <p className="mb-0" role="status">
            {t("loadingReceipt")}
          </p>
        </div>
      );
    }

    return (
      <div className="card-body status-panel" role="alert">
        <h2 className="mb-2">
          {status === "notFound" ? t("receiptNotFoundTitle") : t("loadFailed")}
        </h2>
        <p className="text-muted mb-4">
          {status === "notFound"
            ? t("receiptNotFoundBody")
            : t("loadFailedBody")}
        </p>
        {status === "error" ? (
          <button
            type="button"
            className="btn btn-primary btn-lg mb-3"
            onClick={() => window.location.reload()}
          >
            {t("tryAgain")}
          </button>
        ) : (
          <NavLink to="/" className="btn btn-primary btn-lg mb-3">
            {t("goToPayment")}
          </NavLink>
        )}
        <p className="mb-0 text-small">
          {t("needHelp")}{" "}
          <a href="tel:+998712300103">+998 71 230 01 03</a>
        </p>
      </div>
    );
  };

  return (
    <PublicLayout>
      <Col lg="6" md="12" className="mx-auto">
        <div className="card mt-2 public-card">{renderState()}</div>
      </Col>
    </PublicLayout>
  );
};

export default VerificationHome;
